export default "__VITE_ASSET__D2p7ztP6__"